import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'mage-react-router';
import classNames from 'classnames';
import { isFinite, toNumber } from 'lodash';
import { Button, Loading } from 'sugar-design';
import * as sdf from '@SDFoundation';

import Breadcrumb from '@/components/common/Breadcrumb';
import Dialog from '@/components/common/Dialog';
import JobInfo from '@/components/job/JobInfo';
import JobDescription from '@/components/job/jobDetails/JobDescription';
import JobManagerInfo from '@/components/job/jobDetails/JobManagerInfo';

import { cleanTempResume, uploadCandidate, uploadResume } from '@/redux/actions/applications';
import { fetchJob } from '@/redux/actions/jobs';
import { getI18n } from '@/utils/i18n';

const i18n = getI18n();
class Job extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
    };
    this.openDialog = () => this.setState({ showDialog: true });
    this.closeDialog = () => this.setState({ showDialog: false });
  }

  componentDidMount() {
    window.document.body.scrollTop = 0;
  }
  UNSAFE_componentWillMount() {
    const { orgId, jobId, contractId } = this.props.match.params;

    // 这里兼容旧路由或者手动输入的路由，如果contractId不是数字，就跳转到职位列表
    if (!isFinite(toNumber(contractId))) {
      this.props.history.replace(`/headhunters/${orgId}/org/jobs`);
      return;
    }

    this.props.fetchJob(orgId, jobId, contractId);
  }

  render() {
    const { orgId, jobId, contractId } = this.props.match.params;
    const { orgEntities, loading, contractEntities } = this.props;
    const { showDialog } = this.state;
    const currentJob = contractEntities[`${jobId}_${contractId}`] || {};
    const currentOrg = orgEntities[orgId] || {};
    const jobList = Object.keys(contractEntities).map((key) => contractEntities[key]);
    const { title, headhunterRequirement, jobDescription } = currentJob;
    const breadcrumbArray = [
      {
        name: i18n.t`首页`,
        url: '/headhunters/',
      },
      {
        name: currentOrg.name,
        url: `/headhunters/${currentOrg.id}/org/jobs`,
      },
      {
        name: i18n.t`职位详情`,
      },
    ];

    let applicationNum = null;
    jobList.some((job) => {
      if (`${job.id}_${job.contractId}` === `${currentJob.id}_${currentJob.contractId}`) {
        applicationNum = job.applicationNum;
        return true;
      }
    });

    return (
      <div>
        <div className="jobdetail__header-wrapper">
          <div className="jobdetail__header">
            <Breadcrumb paths={breadcrumbArray} />
            <div className="jobdetail__header-content">
              <div className="jobdetail__info">
                <span className={classNames(sdf.heading50, 'jobdetail__title')}>{title}</span>
                <span className={sdf.bodyPrimary}>{i18n.t`寻访要求：`}</span>
                <div className={classNames(sdf.bodyTertiary, 'jobdetail__info-content')}>
                  {i18n._(headhunterRequirement)}
                  {headhunterRequirement && (
                    <span
                      className="read-more link-alike-btn"
                      onClick={this.openDialog}
                    >{i18n.t`阅读全文`}</span>
                  )}
                </div>
              </div>
              <div className="jobdetail__aside">
                <div>
                  <div className={sdf.heading60}>{applicationNum}</div>
                  <div
                    className={classNames(sdf.bodyPrimary, 'jobdetail__ammount-name')}
                  >{i18n.t`已推荐候选人`}</div>
                </div>
                <div>
                  {!!currentJob.headhunterEnabled && (
                    <Link
                      className="recommend-btn"
                      to={`/headhunters/${orgId}/recommend/${jobId}/${contractId}`}
                    >
                      <Button size="md">{i18n.t`猎头推荐`}</Button>
                    </Link>
                  )}
                  {!!currentJob.rpoEnabled && (
                    <Link
                      className="recommend-btn"
                      to={`/headhunters/${orgId}/recommend/${jobId}/${contractId}?headhunterType=rpo`}
                    >
                      <Button size="md" type="tertiaryLight">{i18n.t`RPO推荐`}</Button>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="panel--empty">
            <Loading />
          </div>
        ) : (
          <div className="job-panel">
            <JobDescription jobDescription={jobDescription} />
            <JobInfo
              currentJob={currentJob}
              headhunterJobFields={currentOrg.headhunterJobFields || {}}
            />
            <JobManagerInfo
              currentJob={currentJob}
              headhunterJobFields={currentOrg.headhunterJobFields || {}}
            />
          </div>
        )}
        <Dialog
          isOpen={showDialog}
          type="md"
          onCancel={this.closeDialog}
          onSubmit={this.closeDialog}
          title={i18n.t`寻访要求`}
        >
          <div dangerouslySetInnerHTML={{ __html: headhunterRequirement }} />
        </Dialog>
      </div>
    );
  }
}

Job.propTypes = {
  orgEntities: PropTypes.object,
};

function mapStateToProps(state) {
  const orgEntities = state.org.entities;
  return {
    orgEntities,
    contractEntities: state.jobs.contractEntities,
    loading: state.jobs.loading,
  };
}

export default connect(mapStateToProps, {
  uploadResume,
  cleanTempResume,
  uploadCandidate,
  fetchJob,
})(Job);
